// extracted by mini-css-extract-plugin
module.exports = {"logoRow":"Title_logoRow__2DBhj"};